module.exports = __webpack_public_path__ + "static/media/zoom-out.fdbf42bd.svg";